import { Partners } from 'utils/constants';

export const getLabels = (modelType: string) => {
    if (modelType === 'mobile' || modelType === 'tablet') {
        return {
            title: 'Enter IMEI number',
            label: 'IMEI number',
            confirmLabel: 'Confirm IMEI number',
            verifyLabel: 'I have verified the IMEI number for plan issuance',
        };
    }
    return {
        title: 'Appliance Serial Number',
        label: 'Serial number',
        confirmLabel: 'Confirm serial number',
        verifyLabel: 'I have verified the serial number',
    };
};

export const isValidIMEI = (imei: string, partnerId?: string) => {
    if (partnerId === Partners.HERO_VIDA) {
        return true;
    }
    if (partnerId === Partners.REALME) {
        return imei.length >= 8 && imei.length <= 20;
    }
    if (imei?.length === 15 && /^[0-9]+$/.test(imei)) return true;
    return false;
};
